import client from '../client'

// 공공데이터 API 상세보기 호출
export default async function getPublicDetail(dictDvsnCd: string, dictUniqId: string) {
  const response = await client.post<any>(`/api/search`, {
    dictDvsnCd: dictDvsnCd === 'KOR_SAM' ? 'KOR_SAM' : dictDvsnCd,
    dictUniqId: dictUniqId,
    requestApi: 'publicDetailUri',
  })

  // 좀 복잡해서 그냥 복붙함
  if (response.data.hasOwnProperty('result')) {
    var resultObjectMap = response.data.result.map
    if (resultObjectMap.hasOwnProperty('RESP_RESULT')) {
      var RESP_RESULT = resultObjectMap.RESP_RESULT.map
      if (RESP_RESULT.hasOwnProperty('PUBLIC_OPEN_DIC')) {
        return RESP_RESULT.PUBLIC_OPEN_DIC.map
      }
    }
  }

  return response.data
}
